
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function SimulatorCTA() {
  return (
    <section className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fd0dd33867294be1b094552c60e5d816.jpg"
          alt="Las Vegas Sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            START YOUR
            <br />
            INVESTMENT
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-4">
            Get started today — completely free
          </p>

          <p className="text-xl md:text-2xl text-gray-300 mb-10">
            Run your ROI simulation now
          </p>

          <Link
            to="/en/advertise#inquiry-form"
            className="inline-flex items-center gap-4 px-8 py-4 bg-black rounded-full hover:bg-gray-900 transition-all cursor-pointer group"
          >
            <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
              <i className="ri-calculator-line text-black text-xl" />
            </div>

            <span className="text-white font-semibold text-lg whitespace-nowrap">
              Book a Consultation
            </span>

            <i className="ri-arrow-right-up-line text-white text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
